// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-modal_wrapper__bzglP {
    padding-top: 20px;
    background: var(--mui-palette-primary-200);
}

.page-modal_content__2f0fn {
    background: var(--mui-palette-primary-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/page-modal/page-modal.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":[".wrapper {\n    padding-top: 20px;\n    background: var(--mui-palette-primary-200);\n}\n\n.content {\n    background: var(--mui-palette-primary-50);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `page-modal_wrapper__bzglP`,
	"content": `page-modal_content__2f0fn`
};
export default ___CSS_LOADER_EXPORT___;
